import type { AqsiProfile } from '../model/types'

function fail(message: string): never {
  throw new Error(message)
}

function objectOf(raw: unknown, what: string): Record<string, unknown> {
  if (typeof raw !== 'object' || raw === null || Array.isArray(raw)) fail(`${what} — не объект`)
  return raw as Record<string, unknown>
}

function text(value: unknown, field: string): string {
  return typeof value === 'string' && value !== '' ? value : fail(`поле ${field} — не строка`)
}

/** `ResourceId` без конвертера сериализуется объектом `{ value }`. */
function idOf(value: unknown): string {
  if (typeof value === 'string') return text(value, 'resourceId')
  return text(objectOf(value, 'resourceId').value, 'resourceId.value')
}

export function decodeAqsiProfile(raw: unknown): AqsiProfile {
  const body = objectOf(raw, 'профиль AQSI')
  if (!Array.isArray(body.capabilities)) fail('поле capabilities — не массив')
  return {
    resourceId: idOf(body.resourceId),
    displayName: text(body.displayName, 'displayName'),
    configurationVersion: text(body.configurationVersion, 'configurationVersion'),
    shopId: text(body.shopId, 'shopId'),
    capabilities: body.capabilities.map((item: unknown, index) => text(item, `capabilities[${index}]`)),
  }
}
